import React, { useEffect, useState } from 'react';
import { formatDate } from '../Utils/formate_date';
import { FilterdData } from '../helper/FilterdData';
import { useNavigate } from 'react-router-dom';
import DataNotFoundView from './DataNotFoundView';
import BootstrapTable from 'react-bootstrap-table-next';
import { Icon } from '@mui/material';

const PaymentData = ({ state }) => {
  const [paymentData, setPaymentData] = useState(state?.PAYMENT || []);
  const [autoPay, setAutoPay] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setPaymentData(FilterdData(state, [...(state?.PAYMENT || [])], 'paymentDate'));
  }, [state?.ACTIVEFILTER, state?.PAYMENT]);


  const latestPayment = paymentData?.reduce((latest, item) => {
    const itemDate = Number(item?.lastDate || 0);
    const latestDate = Number(latest?.lastDate || 0);

    return itemDate > latestDate ? item : latest;
  }, {});
  // const latestPayment = paymentData?.[0] || null;

  const calculateDaysRemaining = (dateStr) => {

    if (!dateStr) return '-';
    const today = new Date();
    const expiry = new Date(dateStr?.length > 10 ? parseInt(dateStr) : parseInt(dateStr * 1000));
    const diff = Math.ceil((expiry - today) / (1000 * 60 * 60 * 24));

    return diff >= 0 ? diff : 0;
  };


  const columns = [
    {
      dataField: 'id',
      text: '#',
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      headerStyle: { width: '60px' },
    },
    {
      dataField: 'device',
      text: 'Device',
      sort: true,
    },
    {
      dataField: 'planName',
      text: 'Plan Name',
      sort: true,
    },
    {
      dataField: 'paymentDate',
      text: 'Payment Date',
      sort: true,
      formatter: (cell) => (cell ? formatDate(cell) : 'N/A'),
    },
    // {
    //   dataField: 'referrerName',
    //   text: 'Referred By',
    //   formatter: (cell, row) => {
    //     if (!row.subscriptionId?.startsWith("REFERRAL_")) return null;
    //     if (!cell || cell.trim() === "" || cell.trim() === "-") return null;
    //     return (
    //       <span className="d-inline-block text-center px-24 py-4 rounded-pill fw-medium text-sm bg-success-focus text-success-main">
    //         {cell}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: 'lastDate',
      text: 'Expiry Date',
      sort: true,
      formatter: (cell) => (cell ? formatDate(cell) : 'N/A'),
    },

  ];

  return (
    <div className="card ">
      <div className="card-body p-4">
        <div className='p-3'>
          {/* ✅ Current Plan Overview */}
          {latestPayment && (
            <div>
              <div className="row g-3">
                <div className="col-md-6 col-sm-6">
                  <label className="small mb-1">Plan Name</label>
                  <div className="fw-semibold border rounded p-2 ">
                    <span className='ps-2'>{latestPayment.planName || 'N/A'}</span>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <label className=" small mb-1">Expiry Date</label>
                  <div className="fw-semibold border rounded p-2 ">
                    <span className='ps-2'>{latestPayment.lastDate ? formatDate(latestPayment.lastDate) : 'N/A'}</span>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6">
                  <label className=" small mb-1">Closes In</label>
                  <div className="fw-semibold border rounded p-2 ">
                    <span className='ps-2'>{calculateDaysRemaining(latestPayment?.lastDate)} days</span>
                  </div>
                </div>
              </div>
              <div
                className="d-flex gap-2 justify-content-start mb-5"
                style={{ marginTop: 20 }}
              >
                {/* <button
                  type="reset"
                  // onClick={() => {
                  //   navigate(-1);
                  // }}
                  className="border btn-sm border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-6 radius-8"
                >
                  Cancle Plan
                </button> */}
                <button
                  type="button"
                  className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center px-40 py-6 radius-8 gap-2"
                  onClick={() => navigate("/pricing")}
                >
                  Change Plan
                </button>
              </div>

            </div>
          )}

          {/* ✅ Transaction Details */}
          <p className="fw-semibold mb-3 mt-5">Transaction History</p>
          <div className="table-responsive">
            <BootstrapTable
              keyField="id"
              data={paymentData || []}
              columns={columns}
              bootstrap4
              bordered={false}
              rowStyle={{ cursor: 'pointer' }}
              defaultSorted={[
                {
                  dataField: 'paymentDate',
                  order: 'desc',
                },
              ]}
              wrapperClasses={`custom-table-border invoice-table ${localStorage.getItem('theme') === 'dark' ? 'table-dark' : 'table-light'
                }`}
              noDataIndication={() => <DataNotFoundView height={400} />}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentData;
